import React from 'react';
import { styled } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { StageStatus } from '../types';

const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  marginRight: theme.spacing(1),
}));

const StyledCheckIcon = styled(CheckCircleIcon)(({ theme }) => ({
  color: theme.palette.success.main,
}));

const StyledErrorIcon = styled(ErrorIcon)(({ theme }) => ({
  color: theme.palette.error.main,
}));

const StyledWarningIcon = styled(WarningIcon)(({ theme }) => ({
  color: theme.palette.warning.main,
}));

const StyledPauseIcon = styled(PauseCircleOutlineIcon)(({ theme }) => ({
  color: theme.palette.grey[500],
}));

const StyledProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

interface StageIconProps {
  status: StageStatus;
  size?: 'small' | 'medium';
}

export const StageIcon: React.FC<StageIconProps> = ({ status, size = 'medium' }) => {
  const iconSize = size === 'small' ? 14 : 18;

  return (
    <IconWrapper>
      {status === 'completed' && <StyledCheckIcon sx={{ fontSize: iconSize }} />}
      {status === 'error' && <StyledErrorIcon sx={{ fontSize: iconSize }} />}
      {status === 'error_continuing' && <StyledWarningIcon sx={{ fontSize: iconSize }} />}
      {status === 'interrupted' && <StyledPauseIcon sx={{ fontSize: iconSize }} />}
      {(status === 'in_progress' || status === 'pending') && (
        <StyledProgress size={iconSize} />
      )}
    </IconWrapper>
  );
}; 